import * as requests from "../../coraWebComponents/utils/requests";
import urls from "../../constants/Urls";

const buildZP_C_PRIORITA = () => {
  return `${urls.ZP_C_PRIORITA}`;
};

export const getZP_C_PRIORITA = async () => {
  const url = buildZP_C_PRIORITA();
  try {
    let res = await requests.get(url);
    return res;
  } catch (error) {
    throw error;
  }
};
